import * as React from "react";

import { getSlots } from "@fluentui/react-utilities";
import { AppContextualMenuProps } from "@1js/acui-menu";
import {
  AppSplitButtonSlots,
  AppSplitButtonState,
} from "./AppSplitButton.types";
import {
  renderSplitButton_unstable,
  SplitButtonState,
} from "@fluentui/react-button";

export const renderAppSplitButton = (state: AppSplitButtonState) => {
  const { slots, slotProps } = getSlots<AppSplitButtonSlots>(state);
  // VSO:5851658 see if we can remove the cast for menu, typescript
  // says the union type is too complex
  const shouldRenderMenu =
    !(slotProps.menu as AppContextualMenuProps).hidden ||
    (state.shadowRenderMenu && state.isShadowRendering) ||
    state.persistMenu;

  return (
    <>
      {renderSplitButton_unstable(state as SplitButtonState)}
      {shouldRenderMenu && <slots.menu {...slotProps.menu} />}
    </>
  );
};
